<template>
  <vs-popup :active.sync="showPopup" id="QRAuthDialog">

    <div class="mb-4" style="padding: 20px 20px 0">
      <h2>QR 체크인</h2>
    </div>


    <!-- 탭 콘텐츠 컨테이너 -->
    <div class="tab-content-container" ref="tabContent" @touchstart="onTouchStart" @touchend="onTouchEnd">
             <div class="tab-content">
         <qr-identity-code v-if="memberInfo" :show="showPopup" @close="onClosePopup" />
       </div>
    </div>
  </vs-popup>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";
import TableListPage from "@/views/list/TableListPage.vue";
import SearchNavItemTartgets from "@/views/boards/components/SearchNavItemTartgets.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import QrAccessList from "@/components/qr/QrAccessList.vue";
import QrAccessCode from "@/components/qr/QrAccessCode.vue";
import QrIdentityCode from "@/components/qr/QrIdentityCode.vue";

export default {
  components: {
    QrIdentityCode,
    QrAccessCode,
    QrAccessList,
    KPagination,
    SearchNavItemTartgets,
    TableListPage,
    VueQRCodeComponent,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    memberInfo() {
      return this.$store.state.member.memberInfo;
    }
  },
  watch: {
    showPopup(showPopup) {
      if (!showPopup) {
        this.selectPost = undefined;
        this.showAccessQrCode = false;
      }
    },
  },
  data() {
    return {
      // 공통 데이터
      showPopup: false,

      activeTab: 0,
      tabs: [
        { label: '작업 입출문 QR' },
        { label: '신분 QR(TBM, 교육)' }
      ],
      touchStartX: 0,
      touchEndX: 0,

      selectPost: undefined,

      // 목록 데이터
      boardId: 0,
      page: 1,
      perPage: 10,
      lastPage: 1,
      total: 0,
      originalDatas: [],

      // QR 데이터
      code: "",
      countdown: 30,
      setTimeout: null,

      // 입출문 QR 코드를 표시할지 여부
      showAccessQrCode: false,
      // 입출문 QR 코드 관련 데이터
      accessQrItem: null,
    };
  },
  mounted() {
    this.showAccessQrCode = false;
    window.addEventListener("qrAuthDialog", this.qrAuthDialog);
  },
  beforeDestroy() {
    this.showAccessQrCode = false;
    window.removeEventListener("qrAuthDialog", this.qrAuthDialog);
  },
  methods: {
    openDialog() {
      this.showPopup = true;
    },

    qrAuthDialog(event) {
      const {open} = event.detail;
      this.showPopup = open || false;
    },

    onClickDetail(row) {
      this.selectPost = row;
    },

    // 탭 전환 메서드
    changeTab(index) {
      this.activeTab = index;
    },

    // 터치 이벤트 시작
    onTouchStart(event) {
      this.touchStartX = event.changedTouches[0].clientX;
    },

    // 터치 이벤트 종료
    onTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.handleSwipe();
    },

    // 스와이프 동작 처리
    handleSwipe() {
      const swipeThreshold = 50; // 최소 스와이프 거리
      const distance = this.touchEndX - this.touchStartX;

      if (distance > swipeThreshold && this.activeTab > 0) {
        this.activeTab -= 1; // 왼쪽 스와이프
      } else if (distance < -swipeThreshold && this.activeTab < this.tabs.length - 1) {
        this.activeTab += 1; // 오른쪽 스와이프
      }
    },

    /**
     * 입출문 QR 코드 리스트가 클릭됐을 때 호출되는 메서드
     * @param item
     */
    onClickAccessItem(item) {
      console.log('onClickAccessItem', item);
      this.showAccessQrCode = true;
      this.accessQrItem = item;
    },

    onCloseAccessCode() {
      this.showAccessQrCode = false;
    },

    onClosePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#QRAuthDialog::v-deep {
  header {
    display: none;
  }

  .vs-popup {
    position: unset;
    width: 94%;
    min-width: 94%;
    max-width: 375px;
    margin: 0;

    .vs-popup--content {
      margin: 0;
      padding: 0;
      width: 100%;
    }
  }
}

p {
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #757575;
  padding: 0;
}

.spin {
  animation: lds-spinner 1s infinite steps(12);
}

.sub-title {
  font-size: 14px;
}

.qr-post-info {
  display: grid;
  gap: 12px;
  margin-bottom: 34px;

  h4 {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #3C3C3C;
  }

  p span {
    font-size: 16px;
    font-weight: 400
  }
}

table {
  border-spacing: 0px;
  border-collapse: separate;

  th {
    background-color: #f2f2f2;
  }

  th, td {
    padding: 8px 8px;
    color: #3C3C3C;
    border-bottom: 1px solid #E0E0E0;
    text-align: center;
  }

}

.tab-container {
  padding: 0 16px;
  .tab-item {
    border-bottom: 1px solid #E0E0E0;
    padding: 7px 0;
    font-weight: 500;
    color: #757575;

    &.active {
      border-bottom: 3px solid #1E0D61;
      color: #1E0D61;
    }
  }
}

.tab-content-container {
  height: 74vh;
  overflow-y: auto;
  padding: 0 16px;

  .tab-content {
    height: 100%;
  }
}


@keyframes lds-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
